// @ts-ignore - deep-freeze has no type declarations available in the project
import deepFreeze from "deep-freeze";

// Returned chart element is deeply frozen (dataset, style, style.seriesColors).
// Callers that need to mutate must clone first — `Element.updateAttributes`
// spreads `...this`, and `ChartDatasetEditor` clones via `cloneDataset`.
// In-place mutation (`element.dataset.rows.push(...)`) will throw in strict mode.
const chartProcess = (element: Record<string, unknown>) => {
  const frozen = deepFreeze(element) as Record<string, unknown>;
  return { ...frozen };
};

export default chartProcess;
